var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "otonomoSubcountryModal",
            size: "lg",
            "content-class": "menu-bg-blue-transparent-modal",
            centered: "",
            title: "Otonomo Subcountries",
            "hide-footer": "",
          },
          on: {
            shown: function ($event) {
              return _vm.createMap()
            },
            hide: function ($event) {
              return _vm.closeOtonomo()
            },
          },
        },
        [
          _c("b-container", [
            _c("div", [
              _vm.view.getZoom() < 9
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c("fa", {
                        staticClass: "collapsed-yellow",
                        attrs: {
                          icon: ["fas", "exclamation-triangle"],
                          size: "3x",
                        },
                      }),
                      _vm._v("\n          ZOOM IN\n        "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "otonomo-controls-row" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { switch: "" },
                      model: {
                        value: _vm.maintainMapView,
                        callback: function ($$v) {
                          _vm.maintainMapView = $$v
                        },
                        expression: "maintainMapView",
                      },
                    },
                    [
                      _vm._v(
                        "\n            Maintain current map view\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.selectedSubcountry
                    ? _c("span", { staticClass: "selected-subcountry" }, [
                        _vm._v(
                          "\n            Selected Subcountry: " +
                            _vm._s(_vm.selectedSubcountry.toUpperCase()) +
                            "\n          "
                        ),
                      ])
                    : _c("span", { staticClass: "selected-subcountry" }, [
                        _vm._v(
                          "\n            No Subcountry Selected\n          "
                        ),
                      ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "ol-map otonomo-map",
              style: _vm.otonomoMapReady
                ? "visibility: visible"
                : "visibility: hidden",
              attrs: { id: "otonomoMap" },
            }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }